export default __webpack_public_path__ + "static/media/tame_let.6c7f3c72.mp3";